import script from "./SearchField.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchField.vue?vue&type=script&setup=true&lang=js"

import "./SearchField.vue?vue&type=style&index=0&id=c3c9f2fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3c9f2fc"]])

export default __exports__